import { finectAPI } from '@finect/front-utils/finectAPI';
import { models } from '../../models';
export function setUser(user) {
  return {
    type: 'SET_USER',
    user: user
  };
}
export function setIntegrations(integrations) {
  return {
    type: 'SET_INTEGRATIONS',
    integrations: integrations
  };
}
export function setUserNotifications(preferences) {
  return {
    type: 'SET_USER_NOTIFICATIONS',
    preferences: preferences
  };
}
export function getLoggedUser(cookie) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: 'users/me',
      method: 'GET',
      credentials: cookie,
      onSuccess: function onSuccess(_ref) {
        var data = _ref.data;
        return dispatch(setUser(models.users(data)));
      },
      onError: function onError() {
        return dispatch(setUser({
          isLoggedIn: false
        }));
      }
    });
  };
}
export function fetchUserNotifications(preferences) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: 'users/me/notifications',
      method: 'PUT',
      body: preferences,
      onSuccess: function onSuccess() {
        dispatch(setUserNotifications(preferences));
      }
    });
  };
}
export function getIntegrations(cookie) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: "users/me/integrations",
      method: 'GET',
      credentials: cookie,
      onSuccess: function onSuccess(_ref2) {
        var data = _ref2.data;
        dispatch(setIntegrations(data));
      },
      onError: function onError() {
        return dispatch(setIntegrations([]));
      }
    });
  };
}